/** Simulador de escala: página pública, sem login. Só simula; nada é gravado. */
export const SIMULADOR_ESCALA_PAGE = () => "/simulador-escala";
